import { queryAddressList, addAddress, editAddress, qureyProvinceList, queryRegionSubInfo } from './api';
import { getUserLoginInfo } from './userInfo';
import { ADDRESS_ADD } from '../utils/keys';
import LStorage from '../utils/LStorage';

export type Address = {
    consignee: string;
    mobilePhone: string;
    provinceCode: string;
    provinceName: string;
    cityCode: string;
    cityName: string;
    areaCode: string;
    areaName: string;
    detailedAddress: string;
    id: string;
    isDefault: 0 | 1;
    userId?: number;
};

/**
 * 获取用户地址列表
 */
export const getAddressList = (): Promise<Address[]> =>
    new Promise(async (resolve, reject) => {
        let userLoginInfo = await getUserLoginInfo();
        let userInfo = userLoginInfo.userInfo;

        queryAddressList({
            userId: userInfo.StudentId,
        }).then(res => {
            if (!res.status) {
                resolve(res.result);
            } else {
                resolve([]);
            }
        });
    });

/**
 * 保存地址信息
 * @param address
 */
export const saveAddressItem = (address: Address): Promise<Address> =>
    new Promise(async (resolve, reject) => {
        const userLoginInfo = await getUserLoginInfo();
        let userInfo = userLoginInfo.userInfo;
        // 添加userid字段
        address.userId = userInfo.StudentId;

        // 未登录
        if (!userLoginInfo.accessToken) {
            // 存储在localstorage
            LStorage.set(ADDRESS_ADD, address);
            resolve(address);
            return;
        }

        let editRes = await (!address.id ? addAddress : editAddress)(address);
        if (!editRes.status) {
            resolve(
                !address.id
                    ? {
                          ...address,
                          id: editRes.result,
                      }
                    : address
            );
        } else {
            reject(editRes.info);
        }
    });

/**
 * 获取默认地址
 * @param addressList 地址列表
 */
export const getDefaultAddress = (addressList: Address[]): Address | null => {
    for (let i = 0; i < addressList.length; i++) {
        if (addressList[i].isDefault) {
            return addressList[i];
        }
    }
    return null;
};

/**
 * 区域字段添加
 */
export const resetRegionLabelAndValue = (regionList: any[]) => {
    regionList.map(region => {
        region.label = region.name;
        region.value = region.id;
    });
    return regionList;
};

/**
 * 获取code对应name
 * @param regionList 地区列表
 * @param value areacode
 */
export const getLabelByValue = (regionList: any[], value: string, labelName = 'label') => {
    for (let i = 0; i < regionList.length; i++) {
        let region = regionList[i];
        if (region.value === value) {
            return region[labelName];
        }
    }
    return '';
};

/**
 * 处理数值适应组件数据
 * @param arr 数组
 */
export const filterArray = (arr?: any[]) => {
    if (!arr) {
        return arr;
    }
    arr.forEach(item => {
        item.children = [];
    });
    return arr;
};

/**
 * 获取省份列表
 */
export const getProvinceList = (): Promise<any[]> =>
    new Promise((resolve, reject) => {
        let list = LStorage.get('ProvinceList');
        if (list) {
            resolve(JSON.parse(list));
        } else {
            qureyProvinceList().then(res => {
                if (!res.status) {
                    let list = filterArray(res.result.children);
                    LStorage.set('ProvinceList', list);
                    resolve(list as any);
                } else {
                    reject(res.info);
                }
            });
        }
    });

export const getRegionSubInfo = (dictCode, optionValue): Promise<any[]> =>
    new Promise((resolve, reject) => {
        let list = LStorage.get(`Province_${dictCode}_${optionValue}_List`);
        if (!!list) {
            resolve(list);
        } else {
            queryRegionSubInfo({
                dictCode: dictCode.toUpperCase(),
                optionValue,
            }).then(res => {
                if (!res.status) {
                    let list = filterArray(res.result.children);
                    LStorage.set(`Province_${dictCode}_${optionValue}_List`, list);
                    resolve(list as any);
                } else {
                    reject(res.info);
                }
            });
        }
    });
